import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spin, Empty, message } from 'antd';
import api from '../services/api';
import PageSkeleton, { ListSkeleton } from '../components/Skeleton';

const TEAL = '#1A6B54';
const INK = '#18140C';
const MUTED = '#685840';
const BG = '#FAF8F5';
const BD = '#E8E0D0';

const STATUS_KEYS = {
  pending:   { key: 'exhibition.statusPending', fallback: '待确认', color: '#E67E22' },
  confirmed: { key: 'exhibition.statusConfirmed', fallback: '已确认', color: TEAL },
  cancelled: { key: 'exhibition.statusCancelled', fallback: '已取消', color: '#95A5A6' },
  completed: { key: 'exhibition.statusCompleted', fallback: '已完成', color: '#3498DB' },
};

export default function MyAppointments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('appointments');

  useEffect(() => {
    Promise.all([
      api.get('/exhibitions/appointments/my').then(r => setAppointments(r.data || [])).catch(() => {}),
      api.get('/exhibitions/flags').catch(() => {}),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <ListSkeleton rows={5} />;

  return (
    <div style={{ background: BG, minHeight: '100vh', paddingBottom: 40 }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', padding: '14px 16px',
          background: '#fff', borderBottom: `1px solid ${BD}`,
        }}>
          <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: INK }}>
            ←
          </button>
          <span style={{ flex: 1, textAlign: 'center', fontWeight: 600, fontSize: 16, color: INK }}>
            {t('exhibition.myAppointments')}
          </span>
          <div style={{ width: 30 }} />
        </div>

        {/* Content */}
        <div style={{ padding: '16px' }}>
          {appointments.length === 0 ? (
            <Empty description={t('exhibition.noAppointments', '暂无预约记录')} style={{ padding: 40 }}>
              <button onClick={() => navigate('/exhibitions')} style={{
                padding: '8px 24px', borderRadius: 6, border: `1px solid ${TEAL}`,
                background: 'transparent', color: TEAL, fontSize: 13, cursor: 'pointer',
              }}>{t('exhibition.browseExhibitions', '浏览展会')}</button>
            </Empty>
          ) : (
            appointments.map(a => {
              const s = STATUS_KEYS[a.status] || STATUS_KEYS.pending;
              return (
                <div key={a.id} style={{
                  background: '#fff', borderRadius: 10, border: `1px solid ${BD}`,
                  padding: 16, marginBottom: 12,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontSize: 14, fontWeight: 600, color: INK }}>
                      {a.exhibition_name || t('exhibition.title')}
                    </span>
                    <span style={{
                      fontSize: 11, padding: '2px 8px', borderRadius: 4,
                      background: `${s.color}15`, color: s.color,
                    }}>{t(s.key, s.fallback)}</span>
                  </div>
                  <div style={{ fontSize: 13, color: INK, marginBottom: 4 }}>
                    {t('exhibition.booth', '展位')} {a.booth_no || '—'}
                    {a.merchant_name && ` · ${a.merchant_name}`}
                  </div>
                  <div style={{ fontSize: 12, color: MUTED, marginBottom: 4 }}>
                    {t('exhibition.appointmentTime', '预约时间')}: {a.appointment_time ? new Date(a.appointment_time).toLocaleString('zh-CN') : '—'}
                  </div>
                  {a.message && (
                    <div style={{ fontSize: 12, color: MUTED }}>{t('exhibition.message', '留言')}: {a.message}</div>
                  )}
                  {a.booth_id && (
                    <button onClick={() => navigate(`/exhibitions/${a.exhibition_id}/booth/${a.booth_id}`)} style={{
                      marginTop: 8, padding: '6px 16px', borderRadius: 6,
                      border: `1px solid ${BD}`, background: '#fff',
                      color: TEAL, fontSize: 12, cursor: 'pointer',
                    }}>{t('exhibition.viewBooth', '查看展位')}</button>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
